import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/app-shell";
import { PumpForm } from "@/components/forms/pump-form";
import { Helmet } from 'react-helmet';
import { useState, useEffect } from "react";

export default function AnalysisPage() {
  const { t } = useTranslation();
  const [initialData, setInitialData] = useState<any>(undefined);

  useEffect(() => {
    try {
      const saved = sessionStorage.getItem("visionExtractedData");
      if (saved) {
        const parsed = JSON.parse(saved);
        setInitialData({
          manufacturer: parsed.manufacturer,
          model: parsed.model,
          hp: parsed.specifications?.hp,
          nameplateHP: parsed.specifications?.hp,
          nameplateRPM: parsed.specifications?.rpm,
          application: parsed.equipmentType,
          powerDrawAmps: parsed.specifications?.amps,
          electricalSetup: `${parsed.specifications?.volts || ''}V ${parsed.specifications?.phase || ''}Phase`.trim(),
          maintenanceHistory: `Visual Condition: ${parsed.condition || 'Unknown'}`
        });
        sessionStorage.removeItem("visionExtractedData");
      }
    } catch (e) {
      console.error("Error parsing vision data", e);
    }
  }, []);

  return (
    <AppShell>
      <Helmet>
        <title>{t("analysis.pageTitle")} | Pump ECM</title>
        <meta name="description" content={t("analysis.pageDescription")} />
      </Helmet>

      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">{t("analysis.title")}</h1>
        <p className="text-muted-foreground">{t("analysis.subtitle")}</p>
      </div>

      <PumpForm initialData={initialData} />
    </AppShell>
  );
}
